import React, { useEffect } from 'react'
import { isEmpty } from '../../../../utils/stringUtils'
import { ActivationObject } from '../../../providers/ActivationObjectProvider/types'
import { DefaultValue, LegalObjectTypeList, PhysicalObjectTypeList } from '../constants'
import { Step2FormConditionsProps, Step2FormOptionsProps, Step2FormProps } from '../types'

const useStep2FormConditions = (
    form: Step2FormProps['form'],
    options: Step2FormOptionsProps,
    activationObject?: ActivationObject
): Step2FormConditionsProps => {
    const objectAddressID = form.watch('objectAddressID')
    const objectZip = form.watch('objectZIP')
    const objectType = form.watch('objectType')
    const objectRegistrationNumber = form.watch('objectRegistrationNumber')
    const objectParcelNumber = form.watch('objectParcelNumber')
    const objectCodeNumber = form.watch('objectCodeNumber')
    const objectGuidanceNumber = form.watch('objectGuidanceNumber')
    const objectGPS = form.watch('objectGPS')
    const guaranteedTime = form.watch('guaranteedArrivalTime')

    const { setValue } = form

    // dopsani ZIPSearch do 5 znaku automaticky zvoli 1. volbu, je-li pouze 1 volba
    React.useEffect(() => {
        const trimmed = options.zipCodeSearch ? options.zipCodeSearch.replace(' ', '') : options.zipCodeSearch
        if (trimmed && trimmed.length === 5 && options.zipCodes.length === 1) setValue('objectZIP', options.zipCodes[0].value)
    }, [options.zipCodeSearch, options.zipCodes, setValue])

    // reset addressID, kdyz se zmeni ZIP
    React.useEffect(() => {
        if (objectZip && objectZip !== activationObject?.objectZIP) {
            setValue('objectAddressID', DefaultValue.objectAddressID)
        }
    }, [activationObject?.objectZIP, objectZip, setValue])

    // reset confirmObjectGPS, kdyz se zmeni GPS
    React.useEffect(() => {
        setValue('confirmObjectGPS', false)
    }, [objectGPS, setValue])

    //nastaveni city name ze city ID
    React.useEffect(() => {
        if (objectAddressID && options.cities) {
            setValue('objectCity', options.cities.find((x) => x.id === objectAddressID)?.name)
        }
    }, [objectAddressID, options.cities, setValue])

    // update objectType if it is not valid
    useEffect(() => {
        if (objectType) {
            if (activationObject?.personType === 'Legal' && !LegalObjectTypeList.find((x) => x.value === objectType)) {
                setValue('objectType', LegalObjectTypeList[0].value)
            }
            if (activationObject?.personType === 'Physical' && !PhysicalObjectTypeList.find((x) => x.value === objectType)) {
                setValue('objectType', PhysicalObjectTypeList[0].value)
            }
        }
    }, [activationObject?.personType, objectType, setValue])

    return {
        enableAnotherObjectType: objectType === 'Another',
        personType: activationObject?.personType || 'Physical',
        enableStreetNumber: !objectRegistrationNumber && !objectParcelNumber,
        enableParcel: !objectRegistrationNumber && isEmpty(objectCodeNumber) && isEmpty(objectGuidanceNumber),
        enableRegistrationNumber: !objectParcelNumber && isEmpty(objectCodeNumber) && isEmpty(objectGuidanceNumber),
        guaranteedTime: guaranteedTime ? guaranteedTime + ' minut' : undefined,
        enableObjectSize: activationObject?.personType === 'Legal',
    }
}

export default useStep2FormConditions
